
<div id="tour_slot_container" class="bg-primary" style="display: inline-flex; flex-direction: row; height: 100%; flex:1; flex-wrap: wrap; overflow-y: auto; overflow-x: hidden; position: relative;">
  <div *ngFor="let map_slot of mapSlots"
       [id]="'tour_slot_' + map_slot.id"
       class="tour_map_container"
       [ngClass]="map_slot.technician_date_collection ? '' : 'hidden' + (mainMapSlot == map_slot ? ' main' : '')"
       [style.width]="map_slot.position?.width || '0'"
       [style.right]="map_slot.position?.right || '0'"
       [style.top]="map_slot.position?.top || '0'"
       [style.height]="map_slot.position?.height || '0'"
       [style.z-index]="map_slot.position?.z_index || '0'"
  >
    <div style="display: inline-flex; flex-direction: column; width: 100%; border: 1px solid black;">
      <div class="control_container bg-primary" style="color: white;" *ngIf="map_slot.technician_date_collection" (click)="$event.stopPropagation()">
        <div style="flex: 1; margin-top: auto; margin-bottom: auto; display: inline-flex; flex-direction: row;">
          <div class="d-flex flex-row" style="margin-top: auto; margin-bottom: auto; margin-left: 4px;white-space: nowrap; font-size: 14px;">
            {{map_slot.technician_date_collection.technician.getFullName(20)}}
            <div style="width: 32px; position: relative">
              <div *ngIf="map_slot.technician_date_collection.technician.country == 'deu' && !PATimeControl.Instance.germanStatesTranslations[map_slot.technician_date_collection.technician.state]"
                   style="position: absolute; right: 0; top: 50%; transform: translateY(-50%); cursor: pointer;"
                   (click)="PATourPlannerControl.Instance.planningAssistantComponent.setStateTechnician = map_slot.technician_date_collection.technician; $event.stopPropagation()"
                   tooltip="Solange für diesen Techniker kein Bundesland festgelegt ist, können keine regionalen Feiertage angezeigt werden. Klicken Sie auf das '!'-Symbol, um ein Bundesland auszuwählen!"
                   [tooltipClass]="'pa_small_tooltip body'"
              >
                <fa-icon class="text-error fs-5" [icon]="faExclamationSquare"></fa-icon>
              </div>
            </div>
          </div>
          <div *ngIf="PASettingsControl.Instance.selectedSettingConfig?.data?.tour_planning?.use_driving_time_factor" class="horizontal_flex" style="margin: auto 4px;">
            <div class="horizontal_flex"
                 style="margin: auto; border: 1px solid black; font-size: .75rem; padding: 1px 2px; border-radius: 2px; cursor: pointer;"
                 [tooltip]="'Durchschnittlicher Fahrtzeitfaktor für ' + map_slot.technician_date_collection.technician.getFullName()"
            >
              <fa-icon [icon]="faCar"></fa-icon>
              <div style="margin: auto 2px;">
                <b>&#10005;</b>
              </div>
              <div>
                <b>{{Math.round(map_slot.technician_date_collection.technician.drivingTimeFactor * 100) / 100}}</b>
              </div>
            </div>
          </div>
        </div>
        <div class="control"
             [ngClass]="map_slot == mainMapSlot ? 'bg-primary' : 'bg-primary cursor-pointer'"
             style="border-right: 2px solid gray;"
             [style.color]="map_slot == mainMapSlot ? 'yellow' : 'gray'"
             (click)="selectMainTourSlot(map_slot)"
        ><fa-icon [icon]="faStar"></fa-icon>
        </div>
        <div *ngIf="!map_slot.minimized" class="control bg-primary cursor-pointer" (click)="minimizeTourSlot(map_slot)"><fa-icon [icon]="faWindowMinimize"></fa-icon></div>
        <div *ngIf="map_slot.minimized" class="control bg-primary cursor-pointer" (click)="unminimizeTourSlot(map_slot)"><fa-icon [icon]="faArrowUp"></fa-icon></div>
        <div *ngIf="!map_slot.maximized" class="control bg-primary cursor-pointer" (click)="maximizeTourSlot(map_slot)"><fa-icon [icon]="faWindowMaximize"></fa-icon></div>
        <div *ngIf="map_slot.maximized" class="control bg-primary cursor-pointer" (click)="restoreTourSlot(map_slot)"><fa-icon [icon]="faWindowRestore"></fa-icon></div>
        <div class="control bg-primary cursor-pointer" (click)="PATourPlannerControl.Instance.removeTechnicianDateCollectionFromOverview(map_slot.technician_date_collection)"><fa-icon [icon]="faWindowClose"></fa-icon></div>
      </div>
      <div class="map_container" [style.display]="map_slot.minimized ? 'none' : 'inline-flex'" >
        <hawk-tour-map style="flex: 1; display: inline-flex; flex-direction: row;" #TourMap
                       [technicianDateCollection]="map_slot.technician_date_collection"
                       [mapBoxAccessToken]="mapBoxAccessToken"
                       [shownTechnicianDates]="map_slot.technician_date_collection?.technicianDates"
                       [shownTours]="map_slot.technician_date_collection?.tours"
                       [currentSelectedTour]="map_slot.technician_date_collection?.selectedTour"
                       [planningInstructions]="planningInstructions"
                       [tourPlannerPlanningMode]="PATourPlannerControl.Instance.tourPlannerPlanningMode"
                       [selectedToursUnfittingOperations]="map_slot.technician_date_collection?.selectedTour ? map_slot.technician_date_collection.selectedTour.technicianDate.changedTourContainer.unfittingOperations : []"
                       [id]="map_slot.id"
                       [tourPlannerExtraOperations]="PATourPlannerControl.Instance.tourPlannerExtraOperationCollection"
                       [operations]="map_slot.operations"
                       [technicianLivePosition]="map_slot.technician_date_collection?.technicianDateWithLivePosition ? map_slot.technician_date_collection.technicianDateWithLivePosition.tour.liveTechnicianPosition : null"
                       [selectedTourMode]="map_slot.technician_date_collection?.showTourMode"
        >
        </hawk-tour-map>
        <div class="filter_menu">
          <div style="width: 24px; display: inline-flex; flex-direction: column; background-color: rgba(0,0,0, .7); border: 1px solid black; border-top-left-radius: 12px; border-bottom-left-radius: 12px;">
            <div style="margin: auto;">
              <fa-icon [icon]="faFilter"></fa-icon>
            </div>
          </div>
          <div style="display: inline-flex; flex-direction: column; background-color: rgba(0,0,0, .7); padding: 2px 4px; border: 1px solid black;">
            <div class="flex_col" style="width: 400px;">

              <label class="bm-input w-full" style="color: black;">
                <input class="bm-checkbox" type="checkbox" [(ngModel)]="map_slot.only_close_operations" (ngModelChange)="toggleOnlyCloseOperations(map_slot)">
                <span class="bm-label w-32">Nur nahe Aufträge</span>
              </label>

              <label class="bm-input w-full" style="color: black;">
                <input class="bm-checkbox" type="checkbox" [(ngModel)]="map_slot.only_time_fitting_operations" (change)="toggleTimeFittingOperations(map_slot)">
                <span class="bm-label w-32">Zeitlich passend</span>
              </label>

              <!-- Reset Filter Button -->
              <button
                *ngIf="map_slot.quick_filter_projects.length > 0 || map_slot.quick_filter_priorities.length > 0"
                class="bm-input w-full"
                style="color: white; background-color: rgba(100, 100, 100, 0.8); border: 1px solid lightgray; cursor: pointer; padding: 4px 8px; display: flex; align-items: center; justify-content: center;"
                (click)="resetProjectFilter(map_slot); $event.stopPropagation()"
              >
                <fa-icon [icon]="faArrowAltCircleLeft" style="margin-right: 6px;"></fa-icon>
                <span>Filter zurücksetzen</span>
              </button>

              <!-- Project Containers -->
              <div *ngFor="let project_container of map_slot.operation_projects_container" style="width: 100%;">
                <!-- Project Row -->
                <div class="project_container" style="display: flex; align-items: center; border: 1px solid lightgray; color: black; background-color: white;">
                  <!-- Expand/Collapse Icon -->
                  <div
                    style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; cursor: pointer; margin-left: 4px;"
                    (click)="toggleProjectExpand(project_container.project, map_slot); $event.stopPropagation()"
                  >
                    <fa-icon
                      [icon]="map_slot.expanded_projects.has(project_container.project.id) ? faChevronDown : faChevronRight"
                      [style.color]="'gray'"
                      style="font-size: 12px;"
                    ></fa-icon>
                  </div>

                  <!-- Project Info (clickable for toggle) -->
                  <div
                    style="flex: 1; display: flex; align-items: center; cursor: pointer; padding: 4px 0;"
                    (click)="toggleProjectQuickSelectForTourSlot(project_container.project, map_slot); $event.stopPropagation()"
                  >
                    <div style="width: 24px; height: 24px; border-radius: 12px; margin-left: 5px; border: 1px solid black; background-color: #323232; display: inline-flex;">
                      <fa-icon style="margin: auto;" [style.color]="map_slot.quick_filter_projects.includes(project_container.project) ? 'gray' : project_container.project.color" [icon]="faFlag"></fa-icon>
                    </div>
                    <span style="flex: 1; display: flex; align-items: center; margin-left: 8px;">
                      <div style="text-align: left; flex: 1;" [style.color]="map_slot.quick_filter_projects.includes(project_container.project) ? 'lightgray' : 'gray'">
                        {{project_container.project.project_name}}
                      </div>
                      <div style="margin-left: 8px;" [style.color]="map_slot.quick_filter_projects.includes(project_container.project) ? 'lightgray' : 'gray'">
                        ({{project_container.amount}})
                      </div>
                    </span>
                  </div>

                  <!-- "Only This" Button -->
                  <button
                    style="padding: 2px 8px; margin-left: 8px; margin-right: 4px; font-size: 11px; background-color: rgba(70, 130, 180, 0.7); color: white; border: 1px solid gray; border-radius: 3px; cursor: pointer; white-space: nowrap;"
                    (click)="selectOnlyProject(project_container.project, map_slot); $event.stopPropagation()"
                    title="Nur dieses Projekt anzeigen"
                  >
                    Einzelansicht
                  </button>
                </div>

                <!-- Priority List (expanded) -->
                <div *ngIf="map_slot.expanded_projects.has(project_container.project.id)" style="margin-left: 28px; border-left: 2px solid lightgray;">
                  <div
                    *ngFor="let priority of project_container.project.priorities"
                    style="display: flex; align-items: center; padding: 2px 8px; cursor: pointer; border-bottom: 1px solid #f0f0f0; background-color: rgba(255, 255, 255, 0.95);"
                    (click)="togglePriorityQuickSelectForTourSlot(priority, project_container.project, map_slot); $event.stopPropagation()"
                  >
                    <div
                      style="width: 16px; height: 16px; border-radius: 8px; margin-left: 5px; border: 1px solid black; display: inline-flex;"
                      [style.background-color]="isPriorityDisabled(priority, project_container.project, map_slot) ? '#d0d0d0' : project_container.project.color"
                    >
                      <div style="margin: auto; width: 8px; height: 8px; border-radius: 4px; background-color: white;" *ngIf="!isPriorityDisabled(priority, project_container.project, map_slot)"></div>
                    </div>
                    <span style="flex: 1; margin-left: 8px; font-size: 13px;" [style.color]="isPriorityDisabled(priority, project_container.project, map_slot) ? 'lightgray' : '#333'">
                      {{priority.name}}
                    </span>
                    <span style="margin-left: 8px; font-size: 11px;" [style.color]="isPriorityDisabled(priority, project_container.project, map_slot) ? 'lightgray' : '#666'">
                      ({{getPriorityOperationCount(priority, project_container.project, map_slot)}})
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
